import * as React from 'react';
import { Card, Container } from 'react-bootstrap';
import { DesktopNav } from 'shared-front-end';
import styles from './AuthShell.module.css';

export const AuthShell = (props: {
  title: string;
  introduction?: React.ReactNode;
  children: React.ReactNode;
  wide?: boolean;
}): React.JSX.Element => (
  <Container className="py-5">
    <Card className={`mx-auto ${styles.card} ${props.wide ? '' : 'mw-100'}`} style={{ maxWidth: props.wide ? 1200 : 560 }}>
      <Card.Body className="p-4 p-md-5">
        <div className="mb-4">
          <DesktopNav
            homeHref="/"
            logoSrc="/assets/icons/careerbook-logo.svg"
            brandName="Careerbook"
          />
        </div>
        <h1 className="h2">{props.title}</h1>
        {props.introduction && <div className="text-body-secondary mb-4">{props.introduction}</div>}
        {props.children}
      </Card.Body>
    </Card>
  </Container>
);

export const safeInternalPath = (value: string | null, fallback: string): string =>
  value?.startsWith('/') && !value.startsWith('//') && !value.includes('\\') ? value : fallback;
